import { PaletteOptions } from '@mui/material'
import { MEDIA } from 'src/constants'
import { IWhiteLabelForm } from 'src/types/white-label-partners.type'

export const breakpointValues = {
  // Defaults
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
  // Custom
  laptop_xl: parseInt(MEDIA.laptop_xl, 10),
  laptop_l: parseInt(MEDIA.laptop_l, 10),
  laptop: parseInt(MEDIA.laptop, 10),
  tablet: parseInt(MEDIA.tablet, 10),
  tablet_s: parseInt(MEDIA.tablet_s, 10),
  mobile_l: parseInt(MEDIA.mobile_l, 10),
  mobile_m: parseInt(MEDIA.mobile_m, 10),
  mobile_s: parseInt(MEDIA.mobile_s, 10),
}

export function createPalette(isDark: boolean, white_label?: IWhiteLabelForm): PaletteOptions {
  return {
    mode: isDark ? 'dark' : 'light',
    ...(isDark
      ? {
          text: {
            primary: '#FFFFFF',
          },
          primary: {
            main: white_label?.primary_color ?? '#3FACA8',
          },
          secondary: {
            main: white_label?.primary_color ?? '#3FACA8',
          },
          custom: {
            primary: white_label?.primary_color ?? '#3FACA8',
            secondary: white_label?.secondary_color ?? '#1A1A1A',
            white: '#121212',
            grey: '#333333',
            greyTransparent: 'rgba(24, 31, 50, 0.5)',
            grey2: '#777777',
            grey3: '#666666',
            black: '#FFFFFF',
            darkBlue2: '#FFFFFF',
            suppressing: '#FF6E3E',
            warning: '#d32f2f',
            warning2: '#FA6971',
            warning3: '#a37671',
            shadowMain: 'rgba(255,255,255, 0.4)',
            surfaceMain: 'rgba(255,255,255, 0.8)',
            lightGreen: '#233534',
          },
        }
      : {
          text: {
            primary: '#181F32',
          },
          primary: {
            main: white_label?.primary_color ?? '#3FACA8',
            contrastText: '#FFFFFF',
          },
          secondary: {
            main: white_label?.primary_color ?? '#3FACA8',
          },
          custom: {
            primary: white_label?.primary_color ?? '#3FACA8',
            secondary: white_label?.secondary_color ?? '#ECF7F6',
            white: '#fff',
            grey: '#EEEEEE',
            greyTransparent: 'rgba(238, 238, 238, 0.5)',
            grey2: '#999999',
            grey3: '#BEBEBE',
            black: '#000',
            darkBlue2: '#181F32',
            suppressing: '#FF6E3E',
            warning: '#d32f2f',
            warning2: '#FA6971',
            warning3: '#fdf4f3',
            shadowMain: 'rgba(0,0,0, 0.1)',
            surfaceMain: 'rgba(0, 0, 0, 0.8)',
            lightGreen: '#ecfafa',
          },
        }),
  }
}
